import { CloseButton, Flex, Icon, Text } from '@chakra-ui/react';
import { AiFillInfoCircle } from 'react-icons/ai';

import { useLocalStorage } from '../../../../hooks';
import { LocalStorageKeys } from '../../../../services/localStorage';
import { sameEmail } from '../../../../utils/customer';
import { initialName } from '../../../../utils/strings';
import { DealStateEnum } from '../../../../utils/types/deal';
import { DealWithFarthestState } from '../../utils';

const BANNER_STATES = [DealStateEnum.Closed, DealStateEnum.SentForSignatures];

type Props = {
  deal: DealWithFarthestState;
};

const CobuyerAcknowledgmentBanner = ({ deal }: Props) => {
  const dealId = deal?.id ?? '';
  const [dismissedDeals, setDismissedDeals] = useLocalStorage<string[]>(
    LocalStorageKeys.COBUYER_BANNER_DISMISSED,
    [],
  );

  const hasSharedEmailCobuyer = !!deal?.cobuyer && sameEmail(deal?.customer, deal?.cobuyer);
  const isVisibleState = BANNER_STATES.includes(deal?.state as DealStateEnum);
  const dismissed = dismissedDeals.includes(dealId);

  const buyerLabel = deal?.customer?.first_name ? initialName(deal.customer) : 'Buyer';
  const cobuyerLabel = deal?.cobuyer?.first_name ? initialName(deal.cobuyer) : 'Co-Buyer';

  const handleDismiss = () => {
    setDismissedDeals((prev) => [...prev, dealId]);
  };

  if (dismissed || !hasSharedEmailCobuyer || !isVisibleState) return null;

  return (
    <Flex
      bg="blue.50"
      border="1px solid"
      borderColor="blue.200"
      borderRadius="12px"
      p={4}
      mb={10}
      align="center"
      gap={3}
    >
      <Icon as={AiFillInfoCircle} color="blue.500" boxSize="20px" mt="2px" flexShrink={0} />
      <Text fontSize="sm" color="gray.700" flex={1}>
        <strong>{buyerLabel}</strong> (Buyer) and <strong>{cobuyerLabel}</strong> (Co-Buyer) both
        need to sign. Complete the steps below for each.
      </Text>
      <CloseButton size="sm" onClick={handleDismiss} />
    </Flex>
  );
};

export default CobuyerAcknowledgmentBanner;
